import React from "react";
import ViolationClassificationTable from "../../../containers/SystemConfigurationTables/ViolationClassificationTable/ViolationClassificationTable";
import { useAppSelector } from "../../../custom-hooks/redux/redux";
import { NotAuthorizedPage } from "../../../reusable-components/NotAuthorizedPage/NotAuthorizedPage";

const ViolationClassification = () => {
  const { currentUserAuthorizations } = useAppSelector((state) => state.currentUserReducer);
  const isAuthorized = currentUserAuthorizations?.canChangeAll || currentUserAuthorizations?.canViewAll;

  return <>{isAuthorized ? <ViolationClassificationTable /> : <NotAuthorizedPage />}</>;
};
export default ViolationClassification;
